var exports = {
  "k": "x4ddf2309--7f0dfd--container",
  "q": "x4ddf2309--7f0dfd--badge",
};

module.exports = exports;
